import React from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import {
  Button,
  FormControl,
  TextField,
  Typography
} from '@mui/material';
import { DebounceInput } from 'react-debounce-input';
import { useMutation } from 'react-fetching-library';
import { useSelector } from 'react-redux';

import { submitModuleViewAction } from '../../../services/request';
import toast from 'react-hot-toast';

export const ViewForm = props => {
  const { loading, mutate } = useMutation(submitModuleViewAction);
  const { data, closeDialog, createViewCallback, updateViewCallback } = props;
  const { module } = useSelector(state => state.app);
  const { olOrderHiddenColumns,
    zsOrderHiddenColumns,
    plOrderHiddenColumns,
    olOrderColumnsWidth,
    zsOrderColumnsWidth,
    plOrderColumnsWidth,
    olOrderColumnsSequence,
    zsOrderColumnsSequence,
    plOrderColumnsSequence,
    olOrderFilters,
    zsOrderFilters,
    plOrderFilters,
    olOrderSearchFields,
    zsOrderSearchFields,
    plOrderSearchFields } = useSelector(state => state.employeeOrderConfig);


  const validationSchema = Yup.object({
    name: Yup.string().required('To pole nie może być puste')
      .max(50, 'Nazwa nie może mięc najwyżej 50 znaków')

  });

  const initialValues = {
    name: ''
  };

  const handleSubmit = async values => {
    const view = data.find(item => item.name === values.name);
    values.module = module;
    values.ol_order_filters = olOrderFilters;
    values.zs_order_filters = zsOrderFilters;
    values.pl_order_filters = plOrderFilters;

    values.ol_order_hidden_columns = olOrderHiddenColumns;
    values.zs_order_hidden_columns = zsOrderHiddenColumns;
    values.pl_order_hidden_columns = plOrderHiddenColumns;

    values.ol_order_columns_width = olOrderColumnsWidth;
    values.zs_order_columns_width = zsOrderColumnsWidth;
    values.pl_order_columns_width = plOrderColumnsWidth;

    values.ol_order_columns_sequence = olOrderColumnsSequence;
    values.zs_order_columns_sequence = zsOrderColumnsSequence;
    values.pl_order_columns_sequence = plOrderColumnsSequence;

    values.ol_order_search_fields = olOrderSearchFields;
    values.zs_order_search_fields = zsOrderSearchFields;
    values.pl_order_search_fields = plOrderSearchFields;

    const { error, payload } = await mutate(values, view === undefined ? 'POST' : 'PATCH', view === undefined ? null : view.id);
    if (!error) {
      closeDialog();
      if (view === undefined) {
        toast.success('Widok został zapisany');
        createViewCallback(payload);
      } else {
        toast.success('Widok został nadpisany');
        updateViewCallback(payload);
      }
    } else {
      // eslint-disable-next-line no-lonely-if
      if (view === undefined) {
        toast.error('Nie udało się zapisać widoku');
      } else {
        toast.error('Nie udało się nadpisać widoku');
      }
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: values => {
      handleSubmit(values);
    }
  });

  return (
    <form onSubmit={formik.handleSubmit} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: 30 }}>
      <FormControl>
        <Typography color="primary" variant="h6">
            Nazwa widoku
        </Typography>
        <DebounceInput
          variant="outlined"
          name="name"
          id="name"
          type="text"
          value={formik.values.name}
          onChange={formik.handleChange}
          error={formik.touched.name && Boolean(formik.errors.name)}
          helperText={formik.touched.name && formik.errors.name}
          debounceTimeout={100}
          element={TextField}
          autoFocus
        />
        <Typography variant="subtitle2" textAlign="center" sx={{ fontSize: '12px', mt: '6px' }}>Podanie nazwy istniejącego widoku spowoduje jego nadpisanie</Typography>
      </FormControl>
      <Button
        color="primary"
        variant="contained"
        type="submit"
        style={{ marginTop: 20 }}
        disabled={loading}
      >
          Zapisz
      </Button>
    </form>
  );
};
